"use client";

import { useLanguage } from "@/hooks/use-language-context";
import React from "react";
import Lottie from "lottie-react";
import emptyAnimation from "@public/assets/json/empty.json";

interface EmptyComponentProps {
  label?: string;
  height?: number; // optionnel
}

const EmptyComponent: React.FC<EmptyComponentProps> = ({
  label,
  height = 150,
}) => {
  const { t } = useLanguage();

  return (
    <div className="flex flex-col items-center justify-center p-4">
      <div style={{ height, width: height }}>
        <Lottie animationData={emptyAnimation} loop={false} />
      </div>
      <p className="text-gray-500 text-sm mt-2 text-center">
        {label ?? t("Empty")}
      </p>
    </div>
  );
};

export default EmptyComponent;
